import React, { Component } from "react";
import { connect } from "react-redux";
import { ROUTE_HOME } from "../../../shared/constants";
import Input from "../../../../shared/Input/Input";
import Select from "./../../../../shared/Select/Select";
import {
	isAllFieldsEmpty,
	returnUserJWT,
	getUserToken,
	getPhoneByState,
	isValidCellPhone,
	fidelityIsNational,
	scrollToComponent
} from "../../../shared/utils";
import R from "ramda";
import {
	getFidelityLogin,
	sendCreateUpdateFidelityLogin,
	deleteFidelityLogin
} from "../../../shared/requests-api";
import Loading from "../../../../shared/Loading/Loading";
import { isNewUser, refreshOffers } from "../../../actions";
import Button from "../../../../shared/button/button";
import Modal from "../../../../shared/Modal/Modal";
import Video from "../../../../shared/Video/Video";
import Callout from "../../../../shared/Callout/Callout";
import { isMobile } from "./../../../../../js/components/searchform/utils/common";
import VMasker from "vanilla-masker";
import { patternOnlyNumbers, phoneNumberMask } from "../../../../shared/create-offer/utils/masks";
import ModalLatamPhone from "../../../../shared/create-offer/ModalPhoneLatam/ModalLatamPhone";
const mmPhone = getPhoneByState(returnUserJWT().state);

const optionPlatform = [
	{
		label: "Android",
		value: "android"
	},
	{
		label: "iPhone",
		value: "iphone"
	},
	{
		label: "Windows Phone",
		value: "windowsphone"
	},
	{
		label: "Blackberry",
		value: "blackberry"
	},
	{
		label: "Outro",
		value: "outro"
	}
];

class AccountLoginOffer extends Component {
	constructor() {
		super();
		this.state = {
			latam: false,
			isMaxPhone: 0,
			phoneMMSuggestion: undefined,
			showModalPhone: false,
			phone: undefined,
			errors: {
				login: undefined,
				password: undefined,
				phone: undefined,
				rescuePassword: undefined
			}
		};

		this.changeFidelity = this.changeFidelity.bind(this);
		this.isValid = this.isValid.bind(this);
		this.confirmSave = this.confirmSave.bind(this);
		this.save = this.save.bind(this);
		this.delete = this.delete.bind(this);
		this.validForm = this.validForm.bind(this);
		this.confirmDelete = this.confirmDelete.bind(this);
	}

	componentDidMount() {
		const { data, loading } = this.props;

		if (!loading && !data) {
			this.props.refreshOffers();
		} else {
			this.handleOffers(this.props);
		}
	}

	componentWillReceiveProps(nextProps) {
		const { error } = nextProps;

		if (error) {
			this.props.isNewUser(true);
		} else {
			this.handleOffers(nextProps);
		}
	}

	handleOffers(props) {
		const { data, loading } = props;
		if (data && data.offers) {
			let fidelitiesOptions = data.offers
				.filter(offer => {
					return offer.fidelity.name != "Amigo";
				})
				.map(offer => {
					let fidelity = offer.fidelity;

					return {
						value: fidelity.id,
						label: fidelity.airlineAcronym,
						highlight: fidelity.name,
						name: fidelity.name,
						link: fidelity.link,
						offerId: offer.offerId,
						status: offer.status,
						quant: offer.quant,
						price: offer.price
					};
				});

			let sorted = R.sortWith([R.ascend(R.path(["highlight"]))]);
			fidelitiesOptions = sorted(fidelitiesOptions);

			this.setState({ fidelitiesOptions, loading });

			if (fidelitiesOptions && fidelitiesOptions.length > 0) {
				this.changeFidelity(fidelitiesOptions[0]);
			}
		} else {
			this.setState({ loading });
		}
	}

	changeFidelity = option => {
		this.setState({ fidelity: option, loadingLogin: true });
		let self = this;
		getFidelityLogin(getUserToken(), option.value)
			.then(response => {
				const {
					username: login,
					password,
					pwAwardSecondary,
					phone,
					isMaxPhone,
					phoneMMSuggestion,
					phoneRequiredMode,
					fidelityForm: {
						editable: {
							password: editablePassword,
							phone: editablePhone,
							rescuePassword: editableRescuePassword,
							user: editableUser
						}
					}
				} = response.data;

				const user = returnUserJWT();

				let errors = self.state.errors;

				errors.login = "";
				errors.password = undefined;
				errors.phone = "";
				errors.rescuePassword = undefined;

				self.setState({
					login: fidelityIsNational(option.value)
						? String(user.ssn).replace(/[^0-9]/g, "")
						: String(login),
					password: String(password),
					phone,
					isMaxPhone,
					phoneRequiredMode,
					phoneMMSuggestion,
					showModalPhone: false,
					rescuePassword: String(pwAwardSecondary),
					loadingLogin: false,
					errors,
					didPasswordReset: false,
					didPasswordRescueReset: false,
					editablePassword,
					editablePhone,
					editableRescuePassword,
					editableUser
				});
			})
			.catch(response => {
				let errors = self.state.errors;

				self.setState({
					login: "",
					password: "",
					phone: undefined,
					isMaxPhone: 0,
					phoneRequiredMode: 0,
					phoneMMSuggestion: "",
					showModalPhone: false,
					rescuePassword: undefined,
					loadingLogin: false,
					errors
				});
			});
	};

	isValid = () => {
		const { fidelity, login, password, rescuePassword, phone, term, errors } = this.state;

		let valid = login && password && isAllFieldsEmpty(errors, "login", "password");
		let phoneValidated = isValidCellPhone(phone);
		if (fidelity && fidelity.label == "Latam") {
			valid =
				valid &&
				phoneValidated &&
				isAllFieldsEmpty(errors, "phone");
		}

		return valid;
	};

	confirmSave() {
		const { errors, fidelity, rescuePassword, password, phone } = this.state;
		if (!this.isValid()) {
			if (password == "" || password == undefined) {
				errors.password = "Campo obrigatório";
			}
			if (fidelity.label == "Latam") {
				if (phone == "" || phone == undefined) {
					errors.phone = "Campo obrigatório";
				} else if (!isValidCellPhone(phone)) {
					errors.phone = "Número de celular inválido";
				}
			}
			this.setState({ errors });
		} else {
			this.save();
		}
	}

	save = () => {
		const { fidelity, login, password, rescuePassword, term, errors } = this.state;

		let phone = this.state.phone.match(patternOnlyNumbers)
			? this.state.phone
					.match(patternOnlyNumbers)
					.join("")
					.toString()
			: "";

		let self = this;
		this.setState({ sending: true });

		sendCreateUpdateFidelityLogin(getUserToken(), {
			id: fidelity.value,
			username: login,
			password: password,
			pwAwardSecondary: rescuePassword,
			phone
		})
			.then(resp => {
				self.setState({ sending: false, showSucesso: true });
			})
			.catch(res => {
				self.setState({ sending: false, showErroStatus: true });
			});
	};

	delete = () => {
		const { fidelity } = this.state;

		if (fidelity.status != 0) {
			this.setState({ showAviso: true });
		} else {
			this.setState({ showDelete: true });
		}
	};

	confirmDelete = () => {
		const { fidelity } = this.state;

		deleteFidelityLogin(fidelity.value)
			.then(response => {
				this.setState({
					login: "",
					password: "",
					phone: undefined,
					rescuePassword: undefined,
					loadingLogin: false,
					errors: [],
					showDelete: false
				});
			})
			.catch(response => {
				this.setState({ showDelete: false });
			});
	};

	onChangePhone = value => {
		const { phoneMMSuggestion, errors } = this.state;

		let phoneInfo = value.match(patternOnlyNumbers)
			? value
					.match(patternOnlyNumbers)
					.join("")
					.toString()
			: "";

		if (phoneInfo === phoneMMSuggestion) {
			this.setState({ isMaxPhone: 1 });
		} else {
			this.setState({ isMaxPhone: 0 });
		}

		if (phoneInfo == "" || phoneInfo == undefined) {
			errors.phone = "Campo obrigatório";
		} else if (!isValidCellPhone(phoneInfo)) {
			errors.phone = "Número de celular inválido";
		} else {
			errors.phone = "";
		}

		this.setState({ phone: phoneInfo, errors });
	};
	handleResetPasswordOnFocus = () => {
		if (!this.state.didPasswordReset) {
			this.setState({
				password: "",
				didPasswordReset: true
			});
		}
	};

	handleResetRescuePasswordOnFocus = () => {
		if (!this.state.didPasswordRescueReset) {
			this.setState({
				rescuePassword: "",
				didPasswordRescueReset: true
			});
		}
	};

	validForm(event) {
		const { fidelity, errors } = this.state;
		let gol = fidelity && fidelity.label == "Gol";
		let value = event.target.type == "checkbox" ? event.target.checked : event.target.value;
		errors[event.target.name] = value
			? ""
			: event.target.name == "password"
			? (errors.password = "Senha do programa de fidelidade não confere")
			: `${event.target.title || event.target.name} não confere`;

		if (event.target.name == "password" && gol) {
			if (isNaN(value)) {
				errors.password = "A senha da Smiles deve ter apenas 4 números.";
			} else if (value.length != 4) {
				errors.password = "A senha da Smiles deve ter apenas 4 números.";
			}
		}

		if (event.target.name == "rescuePassword") {
			if (value.length < 5) {
				errors.rescuePassword =
					'A senha de resgate deve ter 5 dígitos. Saiba <u class="request-here" onclick="document.querySelector(\'#howToRequest\').click()">solicitar aqui</u>';
			} else if (isNaN(value)) {
				errors.rescuePassword =
					'A senha de resgate deve ter apenas números. Saiba <u class="request-here" onclick="document.querySelector(\'#howToRequest\').click()">solicitar aqui</u>';
			}
		}

		if (event.target.name == "phone") {
			let phoneInfo = value.match(patternOnlyNumbers)
				? value
						.match(patternOnlyNumbers)
						.join("")
						.toString()
				: "";

			if (value.length < 1) {
				errors.phone = "Campo obrigatório";
			} else if (value.charAt(5) != "" && value.charAt(5) != "9") {
				errors.phone = "Número de celular inválido";
			} else if (!isValidCellPhone(phoneInfo)) {
				errors.phone = "Número de celular inválido";
			}
		}

		if (event.target.name == "login" && (!event.target.value || event.target.value.length < 4)) {
			errors.login = "O usuário deve ter, no mínimo, 4 dígitos";
		}

		this.setState({ [event.target.name]: value, errors });
	}

	renderInputs() {
		const {
			fidelity,
			login,
			password,
			rescuePassword,
			isMaxPhone,
			phoneRequiredMode,
			phoneMMSuggestion,
			showModalPhone,
			errors,
			loadingLogin,
			sending,
			editablePassword,
			editablePhone,
			editableRescuePassword,
			editableUser
		} = this.state;

		const { innerWidth } = window;
		let gol = fidelity && fidelity.label == "Gol";
		const telMask = ["(99) 9999-9999", "(99) 9 9999-9999"];
		let phone = this.state.phone;

		phone =
			phone !== undefined
				? VMasker.toPattern(phone, phone.length == 10 ? telMask[0] : telMask[1])
				: undefined;

		if (!fidelity) {
			return null;
		}

		if (loadingLogin) {
			return <Loading />;
		
		}

		let fields;
		if (fidelity.label == "Latam") {
			fields = (
				<div>
					<div className="row">
						<div className="col-xs-16 col-md-8 form-group">
							<Input
								autoComplete="off"
								label="Usuário do programa de fidelidade*"
								placeholder="Insira o usuário"
								name="login"
								value={login}
								errorMessage={errors.login}
								disabled={!editableUser}
								required
								data-action="account-login-offer-login"
							/>
						</div>
						<div className="col-xs-16 col-md-8 form-group">
							<Input
								autoComplete="off"
								label="Senha do programa de fidelidade*"
								placeholder="Inserir senha"
								value={password}
								name="password"
								type="password"
								autocomplete="off"
								errorMessage={errors.password}
								onFocus={() => this.handleResetPasswordOnFocus()}
								required
								data-action="account-login-offer-password"
								disabled={!editablePassword}
							>
								{this.state.didPasswordReset ? null : <div />}
							</Input>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-16 col-md-8 form-group">
							<Input
								autoComplete="off"
								label={`Telefone cadastrado na ${fidelity.name}*`}
								placeholder="(  )     -    "
								name="phone"
								value={phone}
								onChange={value => {
									this.onChangePhone(value);
									phone = value;
								}}
								pattern="\d*"
								inputMode="numeric"
								maskpattern={telMask}
								mask={phoneNumberMask}
								errorMessage={
									(errors.phone || (isMaxPhone !== 1 && phoneRequiredMode === 0)) &&
									"Telefone inválido"
								}
								tooltip={`É obrigatório alterar o telefone celular cadastrado no site do Latam Pass pelo número indicado pela MaxMilhas.`}
								tooltipDirection={innerWidth < 396 ? "left" : "up"}
								tooltipBiggerSize
								tooltipColor={"gray"}
								required
								data-action="account-login-offer-phone"
								disabled={!editablePhone}
							/>
							{phone && isMaxPhone == 1 && (
								<div className="account-login-offer--phone-check">
									<i className="icon-check" />
									<p>Pronto! Telefone confirmado</p>
								</div>
							)}
							<Callout
								show={isMaxPhone == 0 && phoneRequiredMode === 0}
								criticalWarn
								text={
									<span>
										Atenção! É obrigatório adicionar o número de telefone celular da MaxMilhas no
										seu cadastro Latam Pass. Para alterar,{" "}
										<a onClick={() => this.setState({ showModalPhone: true })}>clique aqui</a>
										{"."}
									</span>
								}
							/>
							<Callout
								show={isMaxPhone == -1 && phoneRequiredMode === 0}
								criticalWarn
								text={
									<span>
										Este número foi desativado e deve ser alterado para outro telefone indicado pela
										MaxMilhas. Para alterar,{" "}
										<a onClick={() => this.setState({ showModalPhone: true })}>clique aqui</a>
									</span>
								}
							/>

							<ModalLatamPhone
								close={() => this.setState({ showModalPhone: false })}
								show={showModalPhone}
								confirm={value => {
									this.setState({ showModalPhone: false });
									this.onChangePhone(value);
								}}
								phoneSugestion={phoneMMSuggestion}
								phone={phone}
							/>
						</div>
					</div>
				</div>
			);
		} else {
			fields = (
				<div className="row">
					<div className="col-xs-16 col-md-8 form-group">
						<Input
							autoComplete="off"
							label="Usuário do programa de fidelidade*"
							placeholder="Insira o usuário"
							value={login}
							name="login"
							errorMessage={errors.login}
							disabled={!editableUser}
							required
							data-action="account-login-offer-login"
						/>
					</div>
					<div className="col-xs-16 col-md-8 form-group">
						<Input
							autoComplete="off"
							label="Senha do programa de fidelidade*"
							placeholder="Inserir senha"
							name="password"
							type="password"
							autocomplete="off"
							value={password}
							errorMessage={errors.password}
							onFocus={() => this.handleResetPasswordOnFocus()}
							required
							data-action="account-login-offer-password"
							maxLength={gol ? 4 : null}
							disabled={!editablePassword}
						>
							{this.state.didPasswordReset ? null : <div />}
						</Input>
					</div>
				</div>
			);
		}

		return (
			<React.Fragment>
				<div className="col-xs-16 text-center no-padding">
					<p className="account-bank-details--title">
						Para sua segurança, as senhas não são exibidas e a quantidade de caracteres não é real.
					</p>
				</div>

				{fields}

				<div className="row">
					<div className="col-xs-3 icon">
						<i
							className="icon-trash icon-trash-color"
							onClick={this.delete}
							data-action="account-login-offer-delete"
						/>
					</div>
					<div className="col-xs-13 text-right">
						<Button
							className="btn btn-cancel"
							onClick={() => (window.location.href = ROUTE_HOME)}
							type="button"
							data-action="account-login-offer-cancel"
						>
							Cancelar
						</Button>
						<Button
							className={`btn btn-primary confirm-button ${sending ? "btn-loading" : ""}`}
							onClick={this.confirmSave}
							disabled={sending}
							type="button"
							data-action="account-login-offer-save"
						>
							{sending ? <Loading /> : "Salvar"}
						</Button>
					</div>
				</div>
			</React.Fragment>
		);
	}

	render() {
		const {
			loading,
			fidelitiesOptions,
			fidelity,
			showAviso,
			showSucesso,
			showDeleteSuccess,
			showDelete,
			showErroStatus,
			showVideoPassword
		} = this.state;

		if (loading) {
			return (
				<div className="panel-content-component">
					<Loading />
				</div>
			);
		}

		return (
			<section className="account-login-offer panel-content-component row no-margin">
				<form className="form-offer" onChange={this.validForm}>
					<div className="row">
						<div
							className="col-xs-16 col-md-4 account-login-offer--offers"
							onClick={isMobile() && (() => scrollToComponent(".account-login-offer--offers"))}
						>
							<p>Selecione o programa de fidelidade:</p>
							<Select
								onChange={this.changeFidelity}
								selected={fidelity}
								options={fidelitiesOptions || []}
								required
								data-action="account-login-offer-fidelity-select"
							/>
						</div>
					</div>

					<div className="row">
						<div className="col-xs-16">
							<hr />
						</div>
					</div>

					{this.renderInputs()}

					<Modal
						title="OFERTA ATIVA"
						description="Antes de excluir os dados de acesso, é necessário remover sua oferta deste programa de fidelidade."
						confirm="Fechar"
						show={showAviso}
						onCancel={() => this.setState({ showAviso: false })}
						onConfirm={() => this.setState({ showAviso: false })}
					/>

					<Modal
						title="OFERTA ATIVA"
						description="Para alterar os seus dados é necessário alterar através da edição da oferta deste programa de fidelidade."
						confirm="Fechar"
						show={showErroStatus}
						onCancel={() => this.setState({ showErroStatus: false })}
						onConfirm={() => this.setState({ showErroStatus: false })}
					/>

					<Modal
						title="EXCLUIR DADOS"
						description="Deseja realmente excluir os dados do seu programa de fidelidade?"
						cancel="Fechar"
						confirm="Sim, excluir"
						show={showDelete}
						onCancel={() => this.setState({ showDelete: false })}
						onConfirm={this.confirmDelete}
					/>

					<Modal
						title="EXCLUÍDO COM SUCESSO"
						description="Seus dados do programa de fidelidade foram excluído com sucesso :)"
						confirm="Fechar"
						show={showDeleteSuccess}
						onCancel={() => this.setState({ showDeleteSuccess: false })}
						onConfirm={() => this.setState({ showDeleteSuccess: false })}
					/>

					<Modal
						title="DADOS ALTERADOS"
						description="Seus dados foram alterados com sucesso :)"
						confirm="Fechar"
						show={showSucesso}
						onCancel={() => this.setState({ showSucesso: false })}
						onConfirm={() => this.setState({ showSucesso: false })}
					/>
					<Video
						description={
							<iframe
								width={isMobile() ? window.screen.availWidth : "560"}
								height="315"
								src="https://www.youtube.com/embed/mUy2d1ggvhc"
								frameBorder="0"
								allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
							/>
						}
						show={showVideoPassword}
						onClose={() => this.setState({ showVideoPassword: false })}
						fixed={true}
					/>
				</form>
			</section>
		);
	}
}

const mapStateToProps = state => ({
	data: state.offers.data,
	loading: state.offers.loading,
	error: state.offers.error
});

const mapDispatchToProps = dispatch => {
	return {
		isNewUser: newUser => dispatch(isNewUser(newUser)),
		refreshOffers: () => dispatch(refreshOffers())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountLoginOffer);
